/**
 * `core/barba/utils/barbaResetScrollPosition.js`
 *  - Barba.js 遷移後のスクロール位置調整
 *
 * 使用方法:
 *  - import {resetScrollPosition} from "./core/barba//utils/barbaResetScrollPosition.js";
 */


import {config} from "../../../config.js";
import {isMobile} from "../../../utils/index.js";
import {getLenisInstance} from "../../momentumScroll/lenis/lenis.js"; // Lenis インスタンスを取得
import {barbaGetTargetScrollPosition} from "./barbaGetTargetScrollPosition.js";
import {barbaScrollManager} from "./barbaScrollManager.js";


/**
 * スクロール位置のリセット処理
 * @param {Object} data - Barba.js の遷移データ
 * enter以前のタイミングだと新ページのスクロール位置を正しく取得できずずれることがあるので注意
 * 同一トランジションに対して複数回実行しないこと（barbaScrollManager.updateが複数実行されることでスクロール位置がずれる）
 */
export async function barbaResetScrollPosition(data) {
  console.log("🔄 Resetting Scroll Position...");

  // スクロール位置を取得
  const position = barbaGetTargetScrollPosition(data);

  // backかforward遷移の場合、IDを更新
  if (data?.trigger === 'back' || data?.trigger === 'forward') {
    barbaScrollManager.update(data?.trigger);
  }

  // スクロール処理の適用
  if (config.momentumScrolling === "gsap" && !isMobile()) {
    console.log("🛝 Using GSAP ScrollSmoother");
    const gsapScrollSmoother = await import(
      /* webpackChunkName: "GsapScrollSmoother" */ "../../momentumScroll/gsapScrollSmoother/gsapScrollSmoother.js"
      );
    if (gsapScrollSmoother.smoother) {
      // await gsapScrollSmoother.smoother.paused(true); // stop
      // await console.log('goto : ' + position.y);
      // await console.log('start: ' + window.scrollY);
      await gsapScrollSmoother.smoother.scrollTop(position.y); // 即時適用（アニメーションなし）
      // await console.log('end  : ' + window.scrollY);
      // await gsapScrollSmoother.smoother.paused(false); // stop
    }
  } else if (config.momentumScrolling === "lenis" && !isMobile()) {
    console.log("✨ Using Lenis");
    const lenis = getLenisInstance(); // Lenis は動的インポート不要

    if (lenis) {
      lenis.resize(); // barba遷移後、lenisがcurrent.containerのサイズを参照してしまい、正常にスクロールができないため、明示的にサイズ変更を連絡
      lenis.scrollTo(position.y, {
        immediate: true,
        lock: true, // スクロールが完了するまで他のスクロールをロック
      });
      requestAnimationFrame(() => lenis.start()); // 次のフレームでスムーズスクロールを再開
    } else {
      window.scrollTo({left: position.x, top: position.y});
    }
  } else {
    console.log("🚀 Default Browser Scroll");
    requestAnimationFrame(() => {
      window.scrollTo({left: position.x, top: position.y});
    });
  }
}